// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1l-wL","productName":"Table_productName__DhhMg"};